export const baseVariants = {
  shape: {
    rounded: "rounded-lg px-4",
    square: "rounded-none px-4",
    pill: "rounded-full px-4",
    icon: "justify-center",
  },
  size: {
    xs: "h-8",
    sm: "h-9",
    base: "h-12",
    md: "h-14",
    lg: "h-16",
  },
};

export const equalSizes = {
  xs: "h-8 w-8",
  sm: "h-9 w-9",
  base: "h-12 w-12",
  md: "h-14 w-14",
  lg: "h-16 w-16",
};

export const iconSizes = {
  xs: 16,
  sm: 18,
  base: 24,
  md: 28,
  lg: 32,
};

export const loaderSizes = {
  xs: "loading-xs",
  sm: "loading-sm",
  base: "loading-md",
  md: "loading-lg",
  lg: "loading-lg",
};
